import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useSite } from '../../context/SiteContext';
import { newsletterAPI } from '../../services/api';
import { toast } from 'react-toastify';
import './Footer.css';

const Footer = () => {
  const { settings } = useSite();
  const [email, setEmail] = useState('');
  const [subLoading, setSubLoading] = useState(false);

  const handleSubscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    setSubLoading(true);
    try {
      const { data } = await newsletterAPI.subscribe({ email });
      toast.success(data.message || 'Inscription réussie !');
      setEmail('');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Erreur lors de l\'inscription');
    } finally {
      setSubLoading(false);
    }
  };

  const year = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="footer-top">
        <div className="container footer-grid">
          {/* Brand */}
          <div className="footer-brand">
            <div className="footer-logo">
              {settings.site_logo_dark || settings.site_logo
                ? <img
                    src={settings.site_logo_dark || settings.site_logo}
                    alt={settings.site_name || 'ARTIMARQ'}
                    style={{ height: 40, width: 'auto', objectFit: 'contain' }}
                  />
                : <>
                    <span className="logo-mark">P</span>
                    <span className="logo-name">{settings.site_name || 'ARTIMARQ'}</span>
                  </>
              }
            </div>
            <p className="footer-tagline">{settings.site_tagline || 'Personnalisation textile professionnelle'}</p>
            <div className="footer-contact-info">
              {settings.site_phone && (
                <a href={`tel:${settings.site_phone}`} className="footer-contact-link">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81a19.79 19.79 0 01-3.07-8.68A2 2 0 012 1h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 8.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/></svg>
                  {settings.site_phone}
                </a>
              )}
              {settings.site_email && (
                <a href={`mailto:${settings.site_email}`} className="footer-contact-link">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
                  {settings.site_email}
                </a>
              )}
              {settings.site_address && (
                <span className="footer-contact-link">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/></svg>
                  {settings.site_address}
                </span>
              )}
            </div>
            {/* Réseaux sociaux */}
            <div className="footer-social">
              {settings.social_facebook  && <a href={settings.social_facebook}  target="_blank" rel="noreferrer" aria-label="Facebook"  className="social-link"><svg viewBox="0 0 24 24" fill="currentColor"><path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"/></svg></a>}
              {settings.social_instagram && <a href={settings.social_instagram} target="_blank" rel="noreferrer" aria-label="Instagram" className="social-link"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"/><path d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37z"/><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/></svg></a>}
              {settings.social_linkedin  && <a href={settings.social_linkedin}  target="_blank" rel="noreferrer" aria-label="LinkedIn"  className="social-link"><svg viewBox="0 0 24 24" fill="currentColor"><path d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z"/><circle cx="4" cy="4" r="2"/></svg></a>}
              {settings.social_tiktok    && <a href={settings.social_tiktok}    target="_blank" rel="noreferrer" aria-label="TikTok"    className="social-link"><svg viewBox="0 0 24 24" fill="currentColor"><path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1V9.01a6.33 6.33 0 00-.79-.05 6.34 6.34 0 00-6.34 6.34 6.34 6.34 0 006.34 6.34 6.34 6.34 0 006.33-6.34V8.95a8.2 8.2 0 004.79 1.53V7.01a4.85 4.85 0 01-1.02-.32z"/></svg></a>}
            </div>
          </div>

          {/* Navigation */}
          <div className="footer-col">
            <h4 className="footer-heading">Produits</h4>
            <ul className="footer-links">
              <li><Link to="/catalogue/t-shirts">T-Shirts</Link></li>
              <li><Link to="/catalogue/polos">Polos</Link></li>
              <li><Link to="/catalogue/sweats">Sweats &amp; Pulls</Link></li>
              <li><Link to="/catalogue/vestes">Vestes</Link></li>
              <li><Link to="/catalogue/casquettes">Casquettes</Link></li>
              <li><Link to="/catalogue">Tout le catalogue</Link></li>
            </ul>
          </div>

          <div className="footer-col">
            <h4 className="footer-heading">Services</h4>
            <ul className="footer-links">
              <li><Link to="/techniques">Nos techniques</Link></li>
              <li><Link to="/catalogue">Studio personnalisation</Link></li>
              <li><Link to="/devis-rapide">Devis rapide</Link></li>
              <li><Link to="/blog">Nos réalisations</Link></li>
              <li><Link to="/faq">FAQ</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          {/* Newsletter */}
          <div className="footer-col footer-newsletter">
            <h4 className="footer-heading">Newsletter</h4>
            <p className="footer-newsletter-desc">Recevez nos offres, conseils et nouveautés directement dans votre boîte mail.</p>
            <form onSubmit={handleSubscribe} className="footer-newsletter-form">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Votre email professionnel"
                required
              />
              <button type="submit" disabled={subLoading}>
                {subLoading ? <span className="spinner" style={{width:'16px',height:'16px'}} /> : 'S\'inscrire'}
              </button>
            </form>
            <p className="footer-gdpr">En vous inscrivant, vous acceptez notre <Link to="/protection-des-donnees">politique de confidentialité</Link>.</p>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container footer-bottom-inner">
          <p>© {year} {settings.site_name || 'ARTIMARQ'}. Tous droits réservés.</p>
          <div className="footer-legal-links">
            <Link to="/mentions-legales">Mentions légales</Link>
            <Link to="/protection-des-donnees">Données &amp; Cookies</Link>
            <Link to="/cgv">CGV</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;